/**
 * @file Bootstraps environment config before loading the main auth flow.
 */

import { renderAuthShell } from "./authShell.js";

async function fetchEnvironmentConfig() {
    const response = await fetch("/bootstrap-config", { cache: "no-store" });
    if (!response.ok) {
        const localhostHint = ["localhost", "127.0.0.1"].includes(window.location.hostname) ?
            " Localhost must be served through the repo bootstrap server so /bootstrap-config is available." :
            "";
        throw new Error(`Failed to load bootstrap config (${response.status}).${localhostHint}`);
    }

    const decoded = await response.json();
    if (!decoded?.firebase?.apiKey || !decoded?.firebase?.projectId) {
        throw new Error("Bootstrap config is missing required firebase values.");
    }
    if (!decoded?.appCheck?.siteKey) {
        throw new Error("Bootstrap config is missing appCheck.siteKey.");
    }
    if (!decoded?.auth?.microsoftTenant || !decoded?.auth?.microsoftPrompt) {
        throw new Error("Bootstrap config is missing Microsoft auth parameters.");
    }

    return decoded;
}

/**
 * Loads env config, publishes it globally, and starts auth.
 */
export async function startBootstrap() {
    renderAuthShell("auth_bootstrap_loading");

    try {
        const envConfig = await fetchEnvironmentConfig();
        window.__DFC_ENV_CONFIG__ = envConfig;

        const authModule = await import("./authController.js");
        await authModule.init();
    } catch (error) {
        console.error("Bootstrap config load failed:", error);
        renderAuthShell("config_blocked", {
            message: "Authentication is unavailable because config/env could not be loaded. Refresh after the environment is fixed.",
        });
    }
}
